import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { GenericNode } from '../agent-tool-result.model';

// Recursively renders a GenericNode (see agent-tool-result): scalars inline, objects as a key/value
// grid, uniform arrays as a table, everything else as a nested list. Instantiated by
// AgentToolResultComponent for the 'generic' view, and by itself for nested nodes.
@Component({
  selector: 'app-agent-tool-result-node',
  templateUrl: './agent-tool-result-node.component.html',
  styleUrls: ['./agent-tool-result-node.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentToolResultNodeComponent {
  readonly node = input.required<GenericNode>();

  // Split by type so the template can narrow via `@if (x; as y)`: strict template checking does not
  // narrow a union by its discriminant on its own.
  protected readonly object = computed(() => {
    const node = this.node();
    return node.type === 'object' ? node : undefined;
  });
  protected readonly table = computed(() => {
    const node = this.node();
    return node.type === 'table' ? node : undefined;
  });
  protected readonly list = computed(() => {
    const node = this.node();
    return node.type === 'list' ? node : undefined;
  });
  // Scalar text to render; undefined for non-scalar nodes. A blank value renders nothing, matching how
  // empty cells already read elsewhere (see formatCell).
  protected readonly scalarText = computed(() => {
    const node = this.node();
    return node.type === 'scalar' ? node.value : undefined;
  });
}
